import apiIntranet from '@a-i/config'

const path = '/intranet-api/intranet/menu/'

export default {
  get: () => {
    return apiIntranet.get(path)
  }
}
